import { Pipe, PipeTransform } from '@angular/core';
import { OrganizationSite } from '../../../api/models/organization-site';

@Pipe({
    name: 'filterSiteByName',
})
export class FilterSiteByNamePipe implements PipeTransform {
    transform(items: OrganizationSite[], filterBy: string): OrganizationSite[] {
        if (!items) return [];
        if (!filterBy) return items;
        filterBy = filterBy ? filterBy.toLocaleLowerCase() : '';
        return items.filter(item =>
            item.fullSiteName?.toLocaleLowerCase()?.includes(filterBy)
        );
    }
}
